import { getLS } from 'utils/localStoarge';

const SAVES_ID = 'saves';
const VERSION = '1';

export default class PlayerModel {
  constructor() {
    this.storage = getLS();
    this.storage.onRead.addOnce(this.handleDataRead, this);
    this.version = VERSION;
    this.lastLevel = [0, 0, 0]; // id of last played level for every location
    this.unlockedLocations = 1; // number of unlocked locations
    this.cutscenes = []; // list of displayed cutscenes
    this.onboardings = []; // list of completed onboardings

    this.serializable = ['version', 'unlockedLocations', 'lastLevel', 'onboardings', 'cutscenes'];

    this.storage.loadData();
  }

  /*
  ====================================================================================================
    DATA MANAGEMENT
  ====================================================================================================
  */
  handleDataRead() {
    this.storage.onRead.remove(this.handleDataRead, this);
    // console.log(this.storage.data);
    if (this.storage.data[SAVES_ID]) {
      this.deserialize(this.storage.data[SAVES_ID]);
    } else {
      this.save();
    }
  }

  save() {
    this.storage.setGameData(SAVES_ID, this.serialize());
  }

  getLastLevel(locationInd) {
    return this.lastLevel[locationInd];
  }

  saveOnboarding(id) {
    if (!this.wasOnboardingDisplayed(id)) {
      this.onboardings.push(id);
      this.save();
    }
  }

  wasOnboardingDisplayed(id) {
    return this.onboardings.indexOf(id) >= 0;
  }

  saveCutscene(id) {
    if (!this.wasCutsceneDisplayed(id)) {
      this.cutscenes.push(id);
      this.save();
    }
  }

  wasCutsceneDisplayed(id) {
    return this.cutscenes.indexOf(id) >= 0;
  }

  /*
  ====================================================================================================
    DATA SERIALIZATION
  ====================================================================================================
  */

  deserialize(data) {
    data = JSON.parse(data);
    if (data) {
      this.serializable.forEach((key) => {
        // console.log(key, data[key]);
        if (data[key] || data[key] === 0) {
          this[key] = data[key];
        }
      });
    }
  }

  serialize() {
    const data = this.serializable.reduce((obj, key) => {
      obj[key] = this[key];
      return obj;
    }, {});
    return JSON.stringify(data);
  }
}
